import api from '../api';

export async function getCurrentUser() {
    const response = await api.get('/user/me');
    return response.data;
}

export async function getUser(userId) {
    const response = await api.get(`/user/${userId}`);
    return response.data;
}

export async function getUsers(userIds) {
    const response = await api.post('/user/batch', userIds);
    return response.data;
}

export async function updateUserBookmarks(articleId) {
    const response = await api.post(`/user/bookmarks/${articleId}`);
    return response.data;
}

export async function toggleUserFriend(friendUserId) {
    const response = await api.post(`/user/friend/${friendUserId}`);
    return response.data;
}

export async function updateProfile(payload) {
    const response = await api.put('/user/profile', payload);
    return response.data;
}

export async function toggleNewsletterSubscription(subscription) {
    const response = await api.put('/user/profile', { isSubscribedToNewsletter: subscription });
    return response.data;
}

export async function updateProfilePrivacy(privacy) {
    const response = await api.put('/user/profile', { privacy });
    return response.data;
}

export async function updateProfilePinnedLocation(name, coords) {
    const response = await api.put('/user/profile', 
        { 
            PinnedLocationPoint : {
                Name: name,
                Coordinates: coords
            }
        });

    return response.data;
}

export const updateLastActive = async () => {
    try {
        await api.post('/user/update-last-active');
        console.log('Last active updated');
    } catch (err) {
        // Silent fail — not critical
        console.warn('Failed to update last active', err);
    }
};